import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface HeroSectionProps {
  isAuthenticated: boolean;
  activeRole?: string | null;
}

const HeroSection = ({ isAuthenticated, activeRole }: HeroSectionProps) => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    if (isAuthenticated && activeRole) {
      navigate(`/${activeRole.toLowerCase()}`);
    } else {
      navigate("/register");
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
          Manage Your Stores
          <span className="text-primary block mt-2">Like a Pro</span>
        </h1>
        <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto">
          The all-in-one platform for inventory management, sales tracking, and business analytics.
          Streamline your operations and grow your business with StorePilot.
        </p>
        <button
          onClick={handleGetStarted}
          className="bg-primary text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-700 transition transform hover:scale-105 shadow-lg flex items-center gap-2 mx-auto"
        >
          {isAuthenticated ? "Go to Dashboard" : "Get Started"}
          <ArrowRight className="w-5 h-5" />
        </button>
        <p className="mt-4 text-gray-500">No credit card required </p>
      </div>
    </section>
  );
};

export default HeroSection;

